import { ProgressProvider, useProgress } from '@bprogress/react';
import { useNavigation, useFetchers } from '@remix-run/react';
import { useEffect, useMemo, type ReactNode } from 'react';

const PROGRESS_COLOR = 'var(--bs-primary)';
const PROGRESS_HEIGHT = '3px';

function NavigationProgress() {
  const { start, stop } = useProgress();
  const navigation = useNavigation();
  const fetchers = useFetchers();

  const isNavigating = useMemo(() => {
    if (navigation.state !== 'idle') return true;
    return fetchers.some((f) => f.state !== 'idle');
  }, [navigation.state, fetchers]);

  useEffect(() => {
    if (isNavigating) {
      start();
    } else {
      stop();
    }
  }, [isNavigating, start, stop]);

  return null;
}

interface ProgressBarProviderProps {
  children: ReactNode;
}

export function ProgressBarProvider({ children }: ProgressBarProviderProps) {
  return (
    <ProgressProvider
      color={PROGRESS_COLOR}
      height={PROGRESS_HEIGHT}
      disableStyle
      options={{
        showSpinner: true,
        minimum: 0.1,
        easing: 'ease',
        speed: 200,
        trickle: true,
        trickleSpeed: 200,
      }}
    >
      <NavigationProgress />
      {children}
    </ProgressProvider>
  );
}
